import { NativeStackScreenProps } from '@react-navigation/native-stack';
import { Blockchain, DigitalAsset } from '../../../../../../packages/utx-access-client/src/react';

export interface DigitalDepositModalProps {
  onLayout: (event: any) => void;
}

export enum DigitalDepositStackRoutes {
  List = 'list',
  Address = 'address'
}

export type DigitalDepositStackParamList = {
  [DigitalDepositStackRoutes.List]: DigitalDepositModalProps & {
    account: string;
    record?: any;
    refresh?: () => void;
  };
  [DigitalDepositStackRoutes.Address]: DigitalDepositModalProps & {
    account: string;
    refresh?: () => void;
    record?: DigitalAsset & { assetChains: string[]; chains?: Blockchain[] };
    onChangeView?: () => void;
  };
};

export type DigitalDepositStackScreenProps<Screen extends keyof DigitalDepositStackParamList> = NativeStackScreenProps<
  DigitalDepositStackParamList,
  Screen
>;
